<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.title" clearable placeholder="标题" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.topicId" clearable placeholder="Topic ID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.categoryId" clearable filterable placeholder="一级分类" @change="handleFilterCategoryChange">
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="formatTaxonomyLabel(item)"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.subcategoryId" clearable filterable placeholder="二级分类">
            <el-option
              v-for="item in filterSubcategories"
              :key="item.id"
              :label="formatTaxonomyLabel(item)"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="状态">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.identityTagKey" clearable placeholder="身份标签">
            <el-option
              v-for="item in identityTagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleCreate">新增 Market</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        :data="results"
        height="100%"
        border
        stripe
        highlight-current-row
      >
        <el-table-column prop="topicId" label="Topic ID" width="120" fixed="left" />
        <el-table-column label="创建时间" min-width="170">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="publisherName" label="发布方" min-width="140" />
        <el-table-column prop="title" label="标题" min-width="220" show-overflow-tooltip />
        <el-table-column label="分类" min-width="180">
          <template slot-scope="scope">
            {{ formatTopicTaxonomy(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="金额" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.amount }} {{ scope.row.currency }}
          </template>
        </el-table-column>
        <el-table-column label="声明身份" min-width="120">
          <template slot-scope="scope">
            {{ renderIdentityKey(scope.row.identityKey) }}
          </template>
        </el-table-column>
        <el-table-column label="审核标签" min-width="160">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.identityTag" type="success">
              {{ scope.row.identityTag.label }}
            </el-tag>
            <span v-else>nil</span>
          </template>
        </el-table-column>
        <el-table-column label="验证" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isVerified ? 'success' : 'info'">
              {{ scope.row.isVerified ? "已验证" : "未验证" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="担保" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isEscrowed ? 'success' : 'info'">
              {{ scope.row.isEscrowed ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="renderStatusType(scope.row.status)">
              {{ renderStatusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="截止时间" min-width="170">
          <template slot-scope="scope">
            {{ formatMaybeDate(scope.row.deadline) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right" align="center">
          <template slot-scope="scope">
            <el-dropdown size="mini" trigger="hover" placement="bottom" @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ cmd: 'view', row: scope.row }">详情</el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'edit', row: scope.row }">编辑</el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'review', row: scope.row }">审核</el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'priority', row: scope.row }">优先展示</el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', row: scope.row }">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="viewVisible" :close-on-click-modal="false" title="Market 详情" width="920px">
      <el-descriptions column="2" border size="mini">
        <el-descriptions-item label="Topic ID">{{ viewTopic.topicId }}</el-descriptions-item>
        <el-descriptions-item label="创建用户">{{ viewTopic.creatorUserId }}</el-descriptions-item>
        <el-descriptions-item label="发布方">{{ viewTopic.publisherName }}</el-descriptions-item>
        <el-descriptions-item label="标题">{{ viewTopic.title }}</el-descriptions-item>
        <el-descriptions-item label="一级分类">
          {{ formatTaxonomyLabel(viewTopic.category, viewTopic.categoryId) }}
        </el-descriptions-item>
        <el-descriptions-item label="二级分类">
          {{ formatTaxonomyLabel(viewTopic.subcategory, viewTopic.subcategoryId) }}
        </el-descriptions-item>
        <el-descriptions-item label="金额">{{ viewTopic.amount }} {{ viewTopic.currency }}</el-descriptions-item>
        <el-descriptions-item label="截止时间">{{ formatMaybeDate(viewTopic.deadline) }}</el-descriptions-item>
        <el-descriptions-item label="身份声明">{{ renderIdentityKey(viewTopic.identityKey) }}</el-descriptions-item>
        <el-descriptions-item label="审核标签">
          {{ viewTopic.identityTag ? viewTopic.identityTag.label : "nil" }}
        </el-descriptions-item>
        <el-descriptions-item label="验证">
          {{ viewTopic.isVerified ? "已验证" : "未验证" }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">{{ renderStatusLabel(viewTopic.status) }}</el-descriptions-item>
        <el-descriptions-item label="担保">{{ viewTopic.isEscrowed ? "是" : "否" }}</el-descriptions-item>
        <el-descriptions-item label="官网" :span="2">{{ viewTopic.website || "nil" }}</el-descriptions-item>
        <el-descriptions-item label="联系方式" :span="2">
          Email: {{ viewTopic.email || "nil" }} |
          Phone: {{ viewTopic.phone || "nil" }} |
          Telegram: {{ viewTopic.telegram || "nil" }} |
          Twitter: {{ viewTopic.twitter || "nil" }} |
          Discord: {{ viewTopic.discord || "nil" }}
        </el-descriptions-item>
        <el-descriptions-item label="Payout Tokens" :span="2">
          {{ viewTopic.payoutTokens && viewTopic.payoutTokens.length ? viewTopic.payoutTokens.join(", ") : "nil" }}
        </el-descriptions-item>
        <el-descriptions-item label="Publisher Intro" :span="2">{{ viewTopic.publisherIntro || "nil" }}</el-descriptions-item>
        <el-descriptions-item label="Requirements" :span="2">{{ viewTopic.requirements || "nil" }}</el-descriptions-item>
        <el-descriptions-item label="Notes" :span="2">{{ viewTopic.notes || "nil" }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="topicFormVisible"
      :close-on-click-modal="false"
      :title="topicFormMode === 'create' ? '新增 Market' : '编辑 Market'"
      width="980px"
    >
      <el-form ref="topicFormRef" :model="topicForm" :rules="topicFormRules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="创建用户ID" prop="creatorUserId">
              <el-input v-model="topicForm.creatorUserId" placeholder="请输入创建用户 ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布方名称" prop="publisherName">
              <el-input v-model.trim="topicForm.publisherName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="一级分类" prop="categoryId">
              <el-select v-model="topicForm.categoryId" filterable placeholder="请选择一级分类" style="width: 100%" @change="handleFormCategoryChange">
                <el-option
                  v-for="item in categories"
                  :key="item.id"
                  :label="formatTaxonomyLabel(item)"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级分类" prop="subcategoryId">
              <el-select v-model="topicForm.subcategoryId" filterable placeholder="请选择二级分类" style="width: 100%">
                <el-option
                  v-for="item in formSubcategories"
                  :key="item.id"
                  :label="formatTaxonomyLabel(item)"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model.trim="topicForm.title" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="金额" prop="amount">
              <el-input v-model.trim="topicForm.amount" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="币种" prop="currency">
              <el-input v-model.trim="topicForm.currency" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份声明">
              <el-select v-model="topicForm.identityKey" style="width: 100%">
                <el-option
                  v-for="item in identityKeyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核标签">
              <el-select v-model="topicForm.identityTagKey" clearable style="width: 100%">
                <el-option label="不设置" :value="''" />
                <el-option
                  v-for="item in identityTagOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <el-select v-model="topicForm.status" style="width: 100%">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否验证">
              <el-switch v-model="topicForm.isVerified" />
              <div class="tips">已验证需要 Market 处于已发布状态，并且设置了身份标签。</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="截止时间">
              <el-date-picker
                v-model="topicForm.deadline"
                type="datetime"
                value-format="timestamp"
                placeholder="请选择截止时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Publisher Avatar">
              <upload v-model="topicForm.publisherAvatar" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="官网">
              <el-input v-model.trim="topicForm.website" />
            </el-form-item>
            <el-form-item label="Escrowed">
              <el-switch v-model="topicForm.isEscrowed" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Email">
              <el-input v-model.trim="topicForm.email" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Phone">
              <el-input v-model.trim="topicForm.phone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Telegram">
              <el-input v-model.trim="topicForm.telegram" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Twitter">
              <el-input v-model.trim="topicForm.twitter" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Discord">
              <el-input v-model.trim="topicForm.discord" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Payout Tokens">
          <el-input
            v-model.trim="topicForm.payoutTokensText"
            placeholder="多个 token 用逗号分隔，例如 USDT, USDC, ETH"
          />
        </el-form-item>
        <el-form-item label="Publisher Intro" prop="publisherIntro">
          <el-input v-model.trim="topicForm.publisherIntro" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="Requirements" prop="requirements">
          <el-input v-model.trim="topicForm.requirements" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="topicFormVisible = false">取消</el-button>
        <el-button :loading="topicSubmitting" type="primary" @click="submitTopicForm">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="reviewVisible" :close-on-click-modal="false" title="审核 Market" width="560px">
      <el-form ref="reviewFormRef" :model="reviewForm" label-width="100px">
        <el-form-item label="Topic ID">
          <el-input :value="reviewForm.topicId" disabled />
        </el-form-item>
        <el-form-item label="标题">
          <el-input :value="reviewForm.title" disabled />
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="reviewForm.status" style="width: 100%">
            <el-option label="待审核" value="pending" />
            <el-option label="通过发布" value="active" />
            <el-option label="关闭/驳回" value="closed" />
          </el-select>
        </el-form-item>
        <el-form-item label="身份标签">
          <el-select v-model="reviewForm.identityTagKey" clearable style="width: 100%">
            <el-option label="不设置" :value="''" />
            <el-option
              v-for="item in identityTagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div class="tips">身份标签可以留空；只有标记为已验证时才必须设置。</div>
        </el-form-item>
        <el-form-item label="是否验证">
          <el-switch v-model="reviewForm.isVerified" />
          <div class="tips">只有已发布并且设置了身份标签的 Market 才能标记为已验证。</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewVisible = false">取消</el-button>
        <el-button :loading="reviewSubmitting" type="primary" @click="submitReview">提交审核</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import Upload from "@/components/Upload";
import { formatDate } from "@/filters";

const createEmptyMarketTopicForm = () => ({
  topicId: "",
  creatorUserId: "",
  publisherName: "",
  publisherIntro: "",
  publisherAvatar: "",
  website: "",
  categoryId: "",
  subcategoryId: "",
  title: "",
  requirements: "",
  notes: "",
  amount: "",
  currency: "USDT",
  phone: "",
  email: "",
  telegram: "",
  twitter: "",
  discord: "",
  identityKey: "directOwner",
  identityTagKey: "",
  isEscrowed: false,
  isVerified: false,
  status: "pending",
  deadline: "",
  payoutTokensText: "",
});

export default {
  name: "MarketTopics",
  components: { Upload },
  data() {
    return {
      mainHeight: "300px",
      listLoading: false,
      results: [],
      page: {
        page: 1,
        limit: 20,
        total: 0,
      },
      filters: {
        title: "",
        topicId: "",
        categoryId: "",
        subcategoryId: "",
        status: "",
        identityTagKey: "",
      },
      categories: [],
      filterSubcategories: [],
      formSubcategories: [],
      statusOptions: [
        { label: "待审核", value: "pending" },
        { label: "已发布", value: "active" },
        { label: "已关闭", value: "closed" },
        { label: "已删除", value: "deleted" },
      ],
      identityKeyOptions: [
        { label: "Direct Owner", value: "directOwner" },
        { label: "Mandate", value: "mandate" },
        { label: "Broker", value: "broker" },
      ],
      identityTagOptions: [
        { label: "Direct Owner | 项目方 / 一手", value: "directOwner" },
        { label: "Mandate | 授权代理", value: "mandate" },
        { label: "Broker | 中介", value: "broker" },
      ],
      viewVisible: false,
      viewTopic: {},
      topicFormVisible: false,
      topicFormMode: "create",
      topicSubmitting: false,
      topicForm: createEmptyMarketTopicForm(),
      topicFormRules: {
        creatorUserId: [{ required: true, message: "请输入创建用户 ID", trigger: "blur" }],
        publisherName: [{ required: true, message: "请输入发布方名称", trigger: "blur" }],
        publisherIntro: [{ required: true, message: "请输入发布方介绍", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择一级分类", trigger: "change" }],
        subcategoryId: [{ required: true, message: "请选择二级分类", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        requirements: [{ required: true, message: "请输入需求内容", trigger: "blur" }],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      reviewVisible: false,
      reviewSubmitting: false,
      reviewForm: {
        topicId: "",
        title: "",
        status: "pending",
        identityTagKey: "",
        isVerified: false,
      },
      reviewTopicPayload: null,
    };
  },
  mounted() {
    mainHeight(this);
    this.loadCategories();
    this.loadFilterSubcategories();
    this.list();
  },
  methods: {
    emptyTopicForm() {
      return createEmptyMarketTopicForm();
    },
    formatTaxonomyLabel(item, fallback) {
      if (!item) {
        return fallback || "";
      }
      const labels = [item.nameZh, item.nameEn].filter((value) => !!value);
      if (labels.length > 0) {
        return labels.join(" / ");
      }
      return item.key || item.id || fallback || "";
    },
    formatTopicTaxonomy(topic) {
      const category = this.formatTaxonomyLabel(topic.category, topic.categoryId);
      const subcategory = this.formatTaxonomyLabel(topic.subcategory, topic.subcategoryId);
      return [category, subcategory].filter((value) => !!value).join(" / ");
    },
    renderStatusLabel(status) {
      const map = {
        pending: "待审核",
        active: "已发布",
        closed: "已关闭",
        deleted: "已删除",
      };
      return map[status] || status || "未知";
    },
    renderStatusType(status) {
      const map = {
        pending: "warning",
        active: "success",
        closed: "info",
        deleted: "danger",
      };
      return map[status] || "";
    },
    renderIdentityKey(value) {
      const map = {
        directOwner: "Direct Owner",
        mandate: "Mandate",
        broker: "Broker",
      };
      return map[value] || value || "nil";
    },
    resolveReviewIdentityTagKey(form) {
      return form.identityTagKey || form.identityKey || "";
    },
    formatMaybeDate(value) {
      return value ? formatDate(value) : "nil";
    },
    normalizeTokens(text) {
      if (!text) {
        return [];
      }
      return text
        .split(",")
        .map((item) => item.trim())
        .filter((item) => !!item);
    },
    buildTopicForm(data) {
      const form = this.emptyTopicForm();
      return Object.assign(form, {
        topicId: data.topicId,
        creatorUserId: data.creatorUserId,
        publisherName: data.publisherName || "",
        publisherIntro: data.publisherIntro || "",
        publisherAvatar: data.publisherAvatar || "",
        website: data.website || "",
        categoryId: data.categoryId || "",
        subcategoryId: data.subcategoryId || "",
        title: data.title || "",
        requirements: data.requirements || "",
        notes: data.notes || "",
        amount: data.amount || "",
        currency: data.currency || "USDT",
        phone: data.phone || "",
        email: data.email || "",
        telegram: data.telegram || "",
        twitter: data.twitter || "",
        discord: data.discord || "",
        identityKey: data.identityKey || "directOwner",
        identityTagKey: data.identityTagKey || "",
        isEscrowed: !!data.isEscrowed,
        isVerified: !!data.isVerified,
        status: data.status || "pending",
        deadline: data.deadline || "",
        payoutTokensText: (data.payoutTokens || []).join(", "),
      });
    },
    serializeTopicForm(form) {
      return {
        topicId: form.topicId,
        creatorUserId: form.creatorUserId,
        publisherName: form.publisherName,
        publisherIntro: form.publisherIntro,
        publisherAvatar: form.publisherAvatar,
        website: form.website,
        categoryId: form.categoryId,
        subcategoryId: form.subcategoryId,
        title: form.title,
        requirements: form.requirements,
        notes: form.notes,
        amount: form.amount,
        currency: form.currency || "USDT",
        phone: form.phone,
        email: form.email,
        telegram: form.telegram,
        twitter: form.twitter,
        discord: form.discord,
        identityKey: form.identityKey || "directOwner",
        identityTagKey: form.identityTagKey || "",
        isEscrowed: !!form.isEscrowed,
        isVerified: !!form.isVerified,
        status: form.status,
        deadline: form.deadline || 0,
        payoutTokens: this.normalizeTokens(form.payoutTokensText).join(","),
      };
    },
    loadCategories() {
      this.axios
        .form("/api/admin/market-category/list", {
          page: 1,
          limit: 100000,
        })
        .then((data) => {
          this.categories = data.results || [];
        });
    },
    loadFilterSubcategories() {
      const params = {
        page: 1,
        limit: 100000,
      };
      if (this.filters.categoryId) {
        params.categoryId = this.filters.categoryId;
      }
      this.axios.form("/api/admin/market-subcategory/list", params).then((data) => {
        this.filterSubcategories = data.results || [];
      });
    },
    loadFormSubcategories(categoryId) {
      const params = {
        page: 1,
        limit: 100000,
      };
      if (categoryId) {
        params.categoryId = categoryId;
      }
      this.axios.form("/api/admin/market-subcategory/list", params).then((data) => {
        this.formSubcategories = data.results || [];
      });
    },
    handleFilterCategoryChange() {
      this.filters.subcategoryId = "";
      this.loadFilterSubcategories();
    },
    handleFormCategoryChange() {
      this.topicForm.subcategoryId = "";
      this.loadFormSubcategories(this.topicForm.categoryId);
    },
    search() {
      this.page.page = 1;
      this.list();
    },
    list() {
      this.listLoading = true;
      const params = Object.assign({}, this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      this.axios
        .form("/api/admin/market-topic/list", params)
        .then((data) => {
          this.results = data.results || [];
          this.page = data.page || { page: 1, limit: 20, total: 0 };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    fetchTopic(topicId) {
      return this.axios.get("/api/admin/market-topic/" + topicId);
    },
    handleCreate() {
      this.topicFormMode = "create";
      this.topicForm = this.emptyTopicForm();
      this.formSubcategories = [];
      this.topicFormVisible = true;
      this.$nextTick(() => {
        this.$refs.topicFormRef && this.$refs.topicFormRef.clearValidate();
      });
    },
    handleEdit(row) {
      this.fetchTopic(row.topicId)
        .then((data) => {
          this.topicFormMode = "edit";
          this.topicForm = this.buildTopicForm(data);
          this.loadFormSubcategories(this.topicForm.categoryId);
          this.topicFormVisible = true;
          this.$nextTick(() => {
            this.$refs.topicFormRef && this.$refs.topicFormRef.clearValidate();
          });
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    handleView(row) {
      this.fetchTopic(row.topicId)
        .then((data) => {
          this.viewTopic = data;
          this.viewVisible = true;
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    handleReview(row) {
      this.fetchTopic(row.topicId)
        .then((data) => {
          const form = this.buildTopicForm(data);
          this.reviewTopicPayload = form;
          this.reviewForm = {
            topicId: form.topicId,
            title: form.title,
            status: form.status,
            identityTagKey: this.resolveReviewIdentityTagKey(form),
            isVerified: !!form.isVerified,
          };
          this.reviewVisible = true;
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    validateIdentityTag(status, identityTagKey, isVerified) {
      if (isVerified && status !== "active") {
        this.$message.error("只有已发布的 Market 才能标记为已验证");
        return false;
      }
      if (isVerified && !identityTagKey) {
        this.$message.error("已验证的 Market 必须设置身份标签");
        return false;
      }
      return true;
    },
    submitTopicForm() {
      this.$refs.topicFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        if (!this.validateIdentityTag(this.topicForm.status, this.topicForm.identityTagKey, this.topicForm.isVerified)) {
          return false;
        }
        const apiUrl =
          this.topicFormMode === "create"
            ? "/api/admin/market-topic/create"
            : "/api/admin/market-topic/update";
        this.topicSubmitting = true;
        this.axios
          .form(apiUrl, this.serializeTopicForm(this.topicForm))
          .then(() => {
            this.$message({
              type: "success",
              message: this.topicFormMode === "create" ? "创建成功" : "更新成功",
            });
            this.topicFormVisible = false;
            this.list();
          })
          .catch((err) => {
            this.$notify.error({ title: "错误", message: err.message || err });
          })
          .finally(() => {
            this.topicSubmitting = false;
          });
      });
    },
    submitReview() {
      if (!this.reviewTopicPayload) {
        return;
      }
      if (!this.validateIdentityTag(this.reviewForm.status, this.reviewForm.identityTagKey, this.reviewForm.isVerified)) {
        return;
      }
      const payload = Object.assign({}, this.reviewTopicPayload, {
        status: this.reviewForm.status,
        identityTagKey: this.reviewForm.identityTagKey,
        isVerified: !!this.reviewForm.isVerified,
      });
      this.reviewSubmitting = true;
      this.axios
        .form("/api/admin/market-topic/update", this.serializeTopicForm(payload))
        .then(() => {
          this.$message({ type: "success", message: "审核成功" });
          this.reviewVisible = false;
          this.list();
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        })
        .finally(() => {
          this.reviewSubmitting = false;
        });
    },
    deleteSubmit(topicId) {
      this.$confirm("是否删除该 Market 主题？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios.form("/api/admin/market-topic/delete", { topicId }).then(() => {
            this.$message({ type: "success", message: "删除成功" });
            this.list();
          });
        })
        .catch(() => {});
    },
    prioritySubmit(topicId) {
      this.axios
        .form("/api/admin/market-topic/priority", { topicId })
        .then(() => {
          this.$message({ type: "success", message: "优先展示成功" });
          this.list();
        })
        .catch((err) => {
          this.$notify.error({ title: "错误", message: err.message || err });
        });
    },
    handleCommand(command) {
      if (command.cmd === "view") {
        this.handleView(command.row);
      } else if (command.cmd === "edit") {
        this.handleEdit(command.row);
      } else if (command.cmd === "review") {
        this.handleReview(command.row);
      } else if (command.cmd === "priority") {
        this.prioritySubmit(command.row.topicId);
      } else if (command.cmd === "delete") {
        this.deleteSubmit(command.row.topicId);
      }
    },
  },
};
</script>

<style scoped>
.tips {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
